import { docsConstants } from '../_constants/docs.constants';

let startState = {
  all: [],
  userDocs: [],
  selected: {},
  shirtSize: [],
  pantSize: [],
  inseamPantSize: [],
  classifications: [],
  race: [],
  crewsList: [],
  stats: [],
  activeForm: {},
};

export function docs(state = startState, action) {
  switch (action.type) {
    // ------------------------------------------------------------
    case docsConstants.DOCS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_LIST_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_LIST_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------
    case docsConstants.DOCS_LIST_ALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_LIST_ALL_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_LIST_ALL_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------
    case docsConstants.DOCS_LIST_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_LIST_FILTER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_LIST_FILTER_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------
    case docsConstants.DOCS_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_TYPE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_TYPE_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------
    case docsConstants.DOCS_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_CATEGORY_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_CATEGORY_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------
    case docsConstants.CATEGORY_DOCS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.CATEGORY_DOCS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.CATEGORY_DOCS_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------

    case docsConstants.DOCS_FORM_GET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_FORM_GET_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_FORM_GET_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------

    case docsConstants.FORM_OPTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.FORM_OPTIONS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.FORM_OPTIONS_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------

    case docsConstants.DOCS_PDF_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_PDF_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_PDF_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------

    case docsConstants.DOCS_STATS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_STATS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_STATS_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------

    case docsConstants.DOCS_SAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case docsConstants.DOCS_SAVE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    case docsConstants.DOCS_SAVE_FAILURE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };
    // ------------------------------------------------------------

    default:
      return state;
  }
}
